import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from './notification.service';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable()
export class ErrorService {

  constructor(
    private notificationService: NotificationService,
    private router: Router
  ) { }

  handlerHttpError(error: HttpErrorResponse) {
    console.log('error handler', error);
    if (error.status === 0) {
      return this.notificationService.toNotifyInfo('It was not possible to communicate with the server');
    } else if (error.status >= 400 && error.status < 500) {
      if (error.status == 403) {
        return this.notificationService.toNotifyError('Access Denied: You do not have permission to access this resource. Please contact your system administrator for assistance.', {}, false);
      }
      else if (error.status == 404) {
        return this.notificationService.toNotifyError('Not Found: Resource isn\'t reachable. Please contact our support team', {}, false);
      }
      if (error.error)
        return this.notificationService.toNotifyInfo(error.error);
      else 
        return this.notificationService.toNotifyInfo(error.error['title']);

    } else if (error.status >= 500 && error.status < 600) {
      if (error.status === 502) { return this.notificationService.toNotifyError('It was not possible to communicate with the server'); }
      return this.notificationService.toNotifyError(error.error);
    }
  }

  handlerErroWithReturn(error: string, route: ActivatedRoute) {
    // this.tratarErroHttp(error);
    this.router.navigate(['../'], { relativeTo: route });
  }

  handlerBlobError(err: any) {
    if (!err || !err.error) {
      return;
    }
    const reader = new FileReader();
    let errorMessage: any;
    const self = this;

    reader.onload = () => {
      try {
        const unsparsedString = JSON.stringify(reader.result);
        errorMessage = JSON.parse(unsparsedString);
        if(!!errorMessage){
          self.notificationService.toNotifyInfo('Ops...', errorMessage);
        }
      } catch (error) {
        console.error(error);
      }
    };
    reader.readAsText(err.error);
  }

}
